import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Smartphone, Monitor, CheckCircle } from 'lucide-react';
import './PublicInfoPage.css';

const DownloadPage = () => {
  const navigate = useNavigate();

  return (
    <div className="pip-root">
      <header className="pip-header">
        <div className="pip-header-inner">
          <img 
            src="/images/avisa.svg" 
            alt="Avisa" 
            className="pip-logo" 
            onClick={() => navigate('/')}
          />
        </div>
      </header>

      <main className="pip-container">
        <div className="pip-card">
          <div className="pip-content-header">
            <h1 className="pip-title">Download</h1>
            <p className="pip-subtitle">Get the Avisa mobile app on your favorite platform</p>
          </div>

          <div className="pip-content-body">
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
              {/* Android Card */}
              <div className="pip-team-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ marginBottom: '20px', color: '#31356e' }}>
                  <Smartphone size={48} />
                </div>
                <h3 className="pip-team-name">Android</h3>
                <p className="pip-team-bio" style={{ flex: 1, margin: '10px 0 20px 0' }}>Experience Avisa on your Android device with full feature access.</p>
                <div style={{ width: '100%' }}>
                  <a
                    href={process.env.REACT_APP_APK_DOWNLOAD_URL || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      backgroundColor: '#31356e',
                      color: 'white',
                      padding: '14px 20px',
                      borderRadius: '10px',
                      textDecoration: 'none',
                      fontWeight: 600,
                      fontSize: '15px',
                      transition: 'background-color 0.2s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#1c1f4e'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#31356e'}
                  >
                    Download APK
                  </a>
                </div>
              </div>

              {/* Windows Card */}
              <div className="pip-team-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div style={{ marginBottom: '20px', color: '#31356e' }}>
                  <Monitor size={48} />
                </div>
                <h3 className="pip-team-name">Windows</h3>
                <p className="pip-team-bio" style={{ flex: 1, margin: '10px 0 20px 0' }}>Install Avisa on your Windows PC for desktop management.</p>
                <div style={{ width: '100%' }}>
                  <a
                    href={process.env.REACT_APP_EXE_DOWNLOAD_URL || '#'}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'block',
                      textAlign: 'center',
                      backgroundColor: '#31356e',
                      color: 'white',
                      padding: '14px 20px',
                      borderRadius: '10px',
                      textDecoration: 'none',
                      fontWeight: 600,
                      fontSize: '15px',
                      transition: 'background-color 0.2s ease',
                      cursor: 'pointer'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#1c1f4e'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = '#31356e'}
                  >
                    Download EXE
                  </a>
                </div>
              </div>
            </div>

            <section className="pip-section" style={{ marginTop: '60px' }}>
              <div className="pip-section-header">
                <span className="pip-section-number">01</span>
                <h3>Why use the Mobile App?</h3>
              </div>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {[
                  "Offline access to bookmarked legal documents",
                  "Push notifications for new ordinance updates",
                  "Simplified document scanning with device camera",
                  "Voice-to-text for AI legal inquiries",
                  "Biometric security for your saved data"
                ].map((feature, i) => (
                  <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px', color: '#475569' }}>
                    <CheckCircle size={16} color="#10b981" />
                    {feature}
                  </li>
                ))}
              </ul>
            </section>

            <footer className="pip-footer">
              <p>© 2026 Avisa. All rights reserved.</p>
            </footer>
          </div>
        </div>
      </main>
    </div>
  );
};

export default DownloadPage;
